export default "__VITE_ASSET__e62b0dd9__"